import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { HidePageLoaderAction, PageLoaderActions } from './page-loader.actions';

@Injectable()
export class PageLoaderEffects {
  private readonly actions$ = inject(Actions);

  hidePageLoader = createEffect(() => this.actions$.pipe(
    ofType<HidePageLoaderAction>(PageLoaderActions.hidePageLoader),
    switchMap(() =>
      Promise.resolve(PageLoaderActions.hidePageLoaderSuccess()),
    ),
  ));
}
